// @flow
import { Map } from "immutable"

type SetInfantsConditions = {|
  type: "SET_INFANT_CONDITIONS",
  payload: Map,
|}

export type Action = SetInfantsConditions

export const setInfantsConditions = (infantsConditions: Map): SetInfantsConditions => ({
  type: "SET_INFANT_CONDITIONS",
  payload: infantsConditions,
})
